export const isQuestionStep = step => step.includes('GQQUESTION:');
